<template>
  <div class="order-success">
    <!--section icon start-->
    <div class="section section-img">
      <img class="icon-hook" src="../common/img/app/hook_red@2x.png"/>
      <h3 class="success-info">购课成功</h3>
    </div>
    <!--section icon end-->

    <!--section consult start-->
    <div class="section section-consult" v-if="consultantInfo.consultantType == 2 && consultantInfo.consultantName && consultantInfo.consultantWechatCode">
      <h3>您的专属顾问</h3>
      <div class="avatar-ctn">
        <img :src="consultantInfo.consultantHeadImgUrl" class="avatar avatar-80"/>
        <div class="consult-name">{{consultantInfo.consultantName||'神秘顾问'}}</div>
        <div class="consult-wechat-info">微信号{{consultantInfo.consultantWechatCode||''}}</div>
      </div>
      <a href="javascript:void(0)" class="mt20 btn btn-size-large btn-red btn-copy-wechatId">复制学习顾问微信号</a>
    </div>
    <div class="section section-consult txt-left" v-else-if="consultantInfo.consultantType == 2">
        我们的学习顾问会在2小时内与您联系，请注意接听电话。
    </div>
    <div class="section section-consult txt-left" v-else>
        班主任会在2小时内与您联系，您也可主动联系班主任了解上课事项。
    </div>
    <!--section consult end-->

    <!--section card start-->
    <div class="section section-card">
      <h3>{{courseInfo.name}}</h3>
      <div class="course-time">
        课程时间：{{courseInfo.displayTime}}
      </div>
      <div class="course-action">
        <a href="javascript:void(0)" class="btn btn-refound" @click="goOrderList">退课</a>
        <span class="course-price-sp">￥{{payAmount}}</span>
      </div>
    </div>
    <!--section card end-->

    <!--section guide start-->
      <div class="section section-guide">
        <h3>上课指南</h3>
        <GuideItem 
            v-for="guide in guides"
            :key="guide.id"
            @opened="onToggleOpen"
            :title="guide.title"
            :openDefault="guide.openDefault"
            :content="guide.content"/>
      </div>
    <!--section guide end-->
  </div>
</template>
<script>
import GuideItem from './GuideItem'
const zbyUrl = 'http://www.weclassroom.com/home/download'
const downloadUrl = 'https://m.izhikang.com/bj/download'
import api from '@/common/libs/api'
import utils from '@/common/libs/utils'
export default {
  name: 'OrderGuide',
  components: {
    GuideItem
  },
  data(){
    return {
      clipboard: null,
      dlClibboard: null,
      wechatId: 'izhikang',
      courseInfo: {},
      payAmount: '',
      consultantInfo: {},
      guides: [{
        id: 1,
        title: '报名成功',
        openDefault: true,
        content: '我们的学习顾问会在<span style="color:red">2小时</span>内与您联系，请注意接听电话。联系学习顾问可以查看授课老师简历。'
      }, {
        id: 2,
        title: '下载软件',
        content: `请复制上课软件“直播云”的下载链接，在电脑浏览器打开并下载（<a class="c-blue btn-copy" href="javascript:void(0)" data-clipboard-action="copy" data-clipboard-text="${zbyUrl}">>>点击复制链接<<</a>）。IPad用户可在苹果应用个商店搜索“直播云”。<p>请使用<span class="c-red">购课填写的手机号</span>进行注册登录</p>`
      }, {
        id: 3,
        title: '按时上课',
        content: '上课前授课老师会和您电话沟通孩子学习情况。如果上课时间变化，请在课前联系学习顾问更换时间。家长可以微信搜索小程序<span class="c-red">“好未来直播云”</span>，实时旁听孩子上课。'
      }, {
        id: 4,
        title: '课后复习',
        content: `课程结束后，在“爱智康APP”中可以查看学习报告。通过上课软件学生可以查看视频回放，按时复习。<a class="c-blue" href="${downloadUrl}">点击下载爱智康APP</a>，在线上课更方便（查课表、看反馈、选课程、轻轻松松全搞定）。`
      }, {
        id: 5,
        title: '温馨提示',
        content: '<p style="font-weight:500">如何上好一节1对1在线课？（勤于反思、自信讲解、爱记笔记）</p><ul><li>· 确保设备和网络环境通过测试，符合上课要求。</li><li>· 准备好一个笔记本，认真记录笔记和错题。</li><li>· 提前5分钟进入教室，适应上课环境。</li><li>· 上课大胆提出疑问，积极回答问题。</li><li>· 课后查看回放，做到按时复习。</li><p style="font-weight:500">有问题及时联系学习顾问。</p>'
      }],
      studentId: '',
      productId: ''
    }
  },
  methods: {
    fetch(){
      api.apiMethod.paySuccessDetail.get({orderId: this.$route.query.orderId}).then(res => {
        if (res.data.errcode === api.CodeMap.Success) {
          this.courseInfo = res.data.data.orderItem[0];
          this.payAmount = res.data.data.payAmount;
          this.consultantInfo = {
            consultantType: res.data.data.consultantType,
            consultantName: res.data.data.consultantName,
            consultantWechatCode: res.data.data.consultantWechatCode||'',
            consultantHeadImgUrl: res.data.data.consultantHeadImgUrl||''
          }
          this.studentId = res.data.data.studentId
          this.productId = this.courseInfo.productId
        }
        utils.bury('enter_page', {
          page_name: 'paysuccess_page',
          order_id: this.$route.query.orderId,
          stu_id: this.studentId,
          channel: this.$route.query.channel,
          user_status: this.consultantInfo.consultantType == 2 && this.consultantInfo.consultantName && this.consultantInfo.consultantWechatCode ? 1 : 0
        });
      })
    },
    onToggleOpen(id){
      if (this.dlClibboard){
        return;
      }
      this.dlClibboard = new ClipboardJS('.btn-copy');
      this.dlClibboard.on('success', e => {
        this.$store.dispatch('toast', {title: '复制成功', show: true});
      })
    },
    goOrderList(){
      //this.$router.replace({name: 'orderList'});
      utils.bury('click_zhenduanke_h5_paysuccess_002', {
        order_id: this.$route.query.orderId,
        channel: this.$route.query.channel,
        course_id: this.productId,
        stu_id: this.studentId
      })
      this.$store.dispatch('toast', {title: '如需退课，请先联系顾问或班主任', show: true});
    }
  },
  mounted(){
     /**不显示页头页尾 */
    this.$store.commit('isShowHeader', {isShowHeader: false});
    this.$store.commit('isShowFooter', {isShowFooter: false});
    this.fetch();
    utils.loadScript('https://static1.izhikang.com/webresource/usertech-public/js/clipboard.min.js', () => {
      let copySupport = ClipboardJS.isSupported(['copy', 'cut'])
      if (!copySupport){
        return;
      }
      this.clipboard&&this.clipboard.destroy();
      this.clipboard = new ClipboardJS('.btn-copy-wechatId', {
          text: trigger => {
              return this.consultantInfo.consultantWechatCode;
          }
      });
      this.clipboard.on('success', e => {
        utils.bury('click_zhenduanke_h5_paysuccess_001', {
          order_id: this.$route.query.orderId,
          channel: this.$route.query.channel,
          course_id: this.productId,
          stu_id: this.studentId
        })
        this.$store.dispatch('toast', {title: '复制成功', show: true});
        e.clearSelection();
      });
    });
  }
}
</script>
<style lang="less" scoped>
.order-success{
  background: #f8f8f8;
}
  .section{
    margin:.10rem .10rem;
    padding:.40rem;
    background: #fff;
    font-size:.28rem;
    &-img{
      text-align: center;
    }
    .icon-hook{
      width:1rem;
      height:1.2rem;
      text-align: center;
      margin:0 auto;
    }
    .success-info{
      text-align: center;
      margin:0 auto;
      text-align: center;
      margin-top:.20rem;
    }
    .course-time{
      color:#999;
      margin-bottom:.40rem;
    }
    .btn-refound{
      border-radius: .28rem;
      border: .02rem solid #CCCCCC;
      width:1.72rem;
      height:.56rem;
      text-align: center;
      line-height: .56rem;
      color:#666;
      display: inline-block;
    }
    .course-price-sp{
      float:right;
      color:#CD0014;
      height:.56rem;
      line-height: .56rem;
      font-size:.4rem;
    }
  }
  .section h3{
    height: .85rem;
    font-size: .32rem;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.85);
    line-height: 0.32rem;
    text-align: left;
  }
  .section-consult{
    margin:0 auto;
    text-align: center;
    .consult-name{
      line-height: .6rem;
      font-size:.32rem;
      font-weight: 500;
      color:#000;
    }
    .consult-wechat-info{
      font-size: .28rem;
      color: #666;
      line-height: .48rem;
      height: .48rem;
    }
     &.txt-left{
       text-align: left !important;
     }
    .btn-size-large{
      font-size:.28rem;
      padding: 0 .60rem;
      border:1px solid #eee;
      display: inline-block;
      height:.72rem;
      line-height: .72rem;
      &.btn-red{
      background: #CD0014;
      border-radius: .36rem;
      color:#fff;
      }
    }
    .avatar-80{
      @size:1.44rem;
      width:@size;
      height: @size;
      border-radius: @size/2;
    }
  }
  
</style>


// WEBPACK FOOTER //
// src/components/orderList/OrderGuide.vue